import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=26bafe9a&"
import script from "./VerifyPage.vue?vue&type=script&lang=js&"
export * from "./VerifyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports